// extracted by mini-css-extract-plugin
export default {"country":"country-yqUsa","country__flag":"country__flag-kfs1X"};